import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {getTaskRelatedComponent} from '../../components/Common/TaskAttributes/ListGroupedDataSelector';
import _ from 'lodash';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function taskRelatedItemReducer(
	state = initialState.taskRelatedItem,
	action
) {
	switch (action.type) {
		case types.GET_TASK_RELATED_ITEM: {
			let taskRelatedItem = action.response;
			let taskRelatedComponent = getTaskRelatedComponent(taskRelatedItem, action.payload);
			taskRelatedItem.taskRelatedObjectData = taskRelatedComponent;
			return {
				...taskRelatedItem,
				isDataLoaded: true,
			};
		}
		case types.RESET_TASK_RELATED_ITEM:
		case types.RESET_TASK_ATTRIBUTES:
		case types.RESET_TASK_DETAIL:
			return {};
		case types.EDIT_TASK_TITLE:{
			if(action?.payload?.path== 'updateControlDesignEffectiveness' || action?.payload?.path== 'updatecontrol'){
				let currentState = _.cloneDeep(state);
				if(currentState?.taskRelatedObjectData && _.size(currentState?.taskRelatedObjectData.scotsControls) > 0){
					currentState.taskRelatedObjectData.scotsControls =_.map(currentState?.taskRelatedObjectData?.scotsControls,(sc)=>{
						if(_.size(sc.controls) > 0){
							let controls =  _.map(sc.controls,(c)=>{
								if(c.controlId==action.payload.value?.id){
									if(action.payload.path== 'updateControlDesignEffectiveness'){
										return {
										...c,
										controlDesignEffectivenessTypeId: action.payload.value.controlDesignEffectivenessTypeId== undefined
										?null
										:action.payload.value.controlDesignEffectivenessTypeId
										}
									}
									return {
										...c,
										isEffective: action.payload.value.isEffective==undefined?null:action.payload.value.isEffective
									}
								}
								else{
									return c;
								}
							});
							sc.controls = controls;
						}
						return sc;
					});
				}
				return currentState;
		}
		return state;
		}
		default:
			return state;
	}
}
